<template>
    <div v-b-tooltip.hover id="deliverable__type__icon" class="project_on_hold" :title="deliverableType">
        <div class="media-call-icon pointer-default">
            <img :src="require(`@/csmworkflow/img/project-on-hold-icon.svg`)" />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: [
        'deliverableTypeId', 
        "deliverableProject",
    ],
    data() {
        return {
            deliverableType: ''
        }
    },
    computed: {
        ...mapGetters([
            'deliverableTypes'
        ]),
        deliverableTypeIcon() {
            let icon = '';
            let typeData = _.filter(this.deliverableTypes, {typeId: this.deliverableTypeId});

            if(typeData.length > 0) {
                icon = typeData[0].typeIcon;
                this.deliverableType = typeData[0].name;
                try {
                    let fileCheck = require(`@/csmworkflow/img/${icon}.svg`);
                } catch (e) {
                    icon = 'project-deliverable';
                }
            } else {
                icon = 'project-deliverable';
                this.deliverableType = 'Deliverable';
            }
            
            return icon;
        }
    },
    methods: {
        applyBackgroundColorIfOnHold(project_id) {
            if (
                project_id &&
                project_id.project_status &&
                project_id.project_status.color &&
                project_id.project_status.slug &&
                project_id.project_status.slug == 'on-hold'
            ) {
                return { backgroundColor: project_id.project_status.color };
            }
            return {};
        },
    },
}
</script>

<style lang="scss">
.deliverable__type__pause__icon {
    color: var(--wf-secondary);
    z-index: 100;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    height: 20px;
    width: 20px;
    border-radius: 10px;
    position: absolute;
    margin-left: 2rem;
    margin-top: 0.5rem;

    i {
        font-size: 0.8rem;
        position: absolute;
        margin-left: 0.35rem;
        margin-top: 0.25rem;
    }
}
</style>